import { PaymentPlanDTOProductTypeEnum, PaymentPlanDTOStatusEnum } from '@reposit/api-client';

export const PAYMENT_PLAN_PRODUCT_TYPE_LABELS: Record<PaymentPlanDTOProductTypeEnum, string> = {
  [PaymentPlanDTOProductTypeEnum.CUSTOM]: 'Custom',
  [PaymentPlanDTOProductTypeEnum.PAYIN3]: 'Pay in 3',
  [PaymentPlanDTOProductTypeEnum.PAYLATER]: 'Pay later',
};

interface PaymentPlanWithStatus {
  status?: PaymentPlanDTOStatusEnum;
}

export const isPaymentPlanInterestCollectible = (paymentPlan?: PaymentPlanWithStatus | null): boolean => {
  return !!(
    paymentPlan &&
    (paymentPlan.status === PaymentPlanDTOStatusEnum.PENDING ||
      paymentPlan.status === PaymentPlanDTOStatusEnum.ACTIVE ||
      paymentPlan.status === PaymentPlanDTOStatusEnum.COMPLETE)
  );
};
